import { TFunction } from 'react-i18next';
import { PropertyType } from '@/models/property.model';

export const getDocumentsSettingSidebarItems = (t: TFunction) => [
  {
    key: PropertyType.DETACHED_HOUSE,
    label: t('tab_detached_house'),
  },
  {
    key: PropertyType.ATTACHED_HOUSE,
    label: t('tab_attached_house'),
  },
  {
    key: PropertyType.DUPLEX,
    label: t('tab_duplex'),
  },
  {
    key: PropertyType.TOWNHOUSE,
    label: t('tab_townhouse'),
  },
  {
    key: PropertyType.APARTMENT,
    label: t('tab_apartment'),
  },
  {
    key: PropertyType.HOLIDAY_HOME,
    label: t('tab_holiday_home'),
  },
];
